// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/pressure-altitude.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/pressure-altitude/pressure-altitude.js';

mount([g0]);
